export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSMSText';
export const NAME = 'SmsText';
